import { supabase, SUPABASE_URL } from '../contexts/AppContext';

export const uploadAvatar = (file: File, onProgress?: (pct: number) => void): Promise<any> => {
  return new Promise(async (resolve) => {
    try {
      const s = await supabase.auth.getSession();
      const token = s?.data?.session?.access_token;
      if (!token) return resolve({ success: false, error: 'No session token' });

      const base = (SUPABASE_URL || '').replace(/\/$/, '');
      const url = `${base}/functions/v1/upload-avatar`;
      const fd = new FormData();
      fd.append('file', file);
      fd.append('cacheControl', '3600');

      const xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);

      xhr.upload.onprogress = (ev) => {
        if (ev.lengthComputable && onProgress) {
          const pct = Math.round((ev.loaded / ev.total) * 100);
          onProgress(pct);
        }
      };

      xhr.onload = () => {
        try {
          const text = xhr.responseText;
          const status = xhr.status;
          let parsed: any = null;
          try { parsed = text ? JSON.parse(text) : null; } catch (e) { parsed = { raw: text }; }
          if (status >= 200 && status < 300) resolve({ success: true, data: parsed });
          else resolve({ success: false, status, body: parsed });
        } catch (e) {
          resolve({ success: false, error: String(e) });
        }
      };

      xhr.onerror = () => resolve({ success: false, error: 'Network error' });
      xhr.send(fd);
    } catch (err) {
      resolve({ success: false, error: String(err) });
    }
  });
};
